import type { Control, FieldValues } from "react-hook-form";

import FormSection from "~/components/formElements/FormSection";
import RadioGroup from "~/components/formElements/RadioGroup";
import { PROJECT_BILLING_SETTINGS_INVOICE_TYPE_OPTIONS } from "~/constants/form.ts";
import BillingSettingsProjectValue
	from "~/modules/billing/components/formSections/components/BillingSettingsProjectValue.tsx";
import type { BillingSettingsDivergingFields } from "~/modules/billing/utils/billingSettingsDisplayUtils.ts";

type Props<T extends FieldValues> = {
	control: Control<T>;
	fieldsDivergingFromProject?: BillingSettingsDivergingFields;
};

interface BillingInvoiceTypeFormData {
	invoiceTypeId: string;
}

const BillingInvoiceTypeFormSection = <T extends BillingInvoiceTypeFormData>({
	control,
	fieldsDivergingFromProject,
}: Props<T>) => {
	return (
		<FormSection title="Rechnungstyp">
			<RadioGroup
				control={control}
				name="invoiceTypeId"
				options={PROJECT_BILLING_SETTINGS_INVOICE_TYPE_OPTIONS}
				numCols={2}
			/>
			{fieldsDivergingFromProject?.invoiceTypeId.isDifferent &&
				<BillingSettingsProjectValue value={fieldsDivergingFromProject?.invoiceTypeId.displayValue} />}

		</FormSection>
	);
};

export default BillingInvoiceTypeFormSection;
